import React, { useContext } from "react";

import { useParams } from "react-router-dom";

import { TSection } from "@data-types/offer/live/Section";
import { OfferStoreContext } from "@gp/components";
import { THEME_SETTINGS } from "@theme-settings";
import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { observer } from "mobx-react";

import { SideMenuLink, SideMenuLinkItem } from ".";

export const PrimaryLiveMenuLinkItems = observer(
	function PrimaryLiveMenuLinkItems() {
		const culture = getCurrentCulture();

		const {
			// @ts-expect-error
			menu: { onCheck },
			// @ts-expect-error
			rootStore: { toggleSideMenu: toggleOfferMenu, closeSideMenu },
			// @ts-expect-error
			setSelectedSport,
			// @ts-expect-error
			selectedSport,

			// @ts-expect-error
			isPlayedLiveEventsCountEnabled,
			// @ts-expect-error
			playedLiveEventsCount,
			// @ts-expect-error
			liveFavoritesCount,
			// @ts-expect-error
			liveFavoriteTournamentsCount,
		} = useContext(OfferStoreContext);

		const { period } = useParams<{ period: string }>();

		const menuLinkItems: SideMenuLinkItem[] = [
			{
				translationKey:
					period === TSection.Matches
						? "LIVE.SIDEMENU.ALL"
						: "LIVE.LIVE_SUB_MENU.LIVE_EVENTS",
				url: `/${culture}/${DefaultPath.LIVE}`,
				iconClassExtension: "all",
				countKey: "liveEventsCount",
				callOnUserAction: () => {
					window.scrollTo(0, 0);
					if (period === TSection.Matches) {
						if (selectedSport != null) {
							onCheck(0);
							setSelectedSport(null);
							closeSideMenu();
						} else {
							toggleOfferMenu();
						}
					} else {
						closeSideMenu();
						setSelectedSport(null);
						onCheck(0);
					}
				},
			},
		];

		if (isPlayedLiveEventsCountEnabled && playedLiveEventsCount > 0) {
			menuLinkItems.push({
				translationKey: "LIVE.SIDEMENU.PLAYED_EVENTS",
				url: `/${culture}/live/played-events`,
				iconClassExtension: "played-events",
				countKey: "playedLiveEventsCount",
			});
		}

		if (
			THEME_SETTINGS.features.isFavoritesEnabled &&
			liveFavoritesCount > 0
		) {
			menuLinkItems.push({
				translationKey: "SPORTS_MENU.MY_FAVORITES.MY_EVENTS",
				url: `/${culture}/live/${TSection.MyFavoritesEvents}`,
				iconClassExtension: "favorites",
				countKey: "liveFavoritesCount",
			});
		}
		if (
			THEME_SETTINGS.features.isFavoritesEnabled &&
			liveFavoriteTournamentsCount > 0
		) {
			menuLinkItems.push({
				translationKey: "SPORTS_MENU.MY_FAVORITES.MY_LEAGUES",
				url: `/${culture}/live/${TSection.MyFavoritesTournaments}`,
				iconClassExtension: "favorite-tournaments--filled",
				countKey: "liveFavoriteTournamentsCount",
			});
		}

		return (
			<>
				{menuLinkItems.map((item, idx) => (
					<SideMenuLink
						key={item.countKey + item.url + idx}
						item={item}
					/>
				))}
			</>
		);
	}
);
